import {itemByCodes} from "@/apis/system/dict"

export default {

    CODE: {
        SYS_USER_SEX: "sys_user_sex",
        CODEGEN_APP_GROUP_TYPE: "codegen_app_group_type",
        SYS_MENU_TYPE: "sys_menu_type",
        SYS_USER_STATUS: "sys_user_status",
        SYS_USER_ACCESS_LEVEL: "sys_user_access_level",
        COMMON_VISIBLE: "common_visible",
        OAUTH_GRANT_TYPE: "oauth_grant_type",
        JX_MAJOR_PROCESS_TYPE: "jx_major_process_type",
        JX_SITE_TYPE: "jx_site_type",
        JX_CLOCK_STATUS: "jx_clock_status",
        JX_EXAM_STATUS: "jx_exam_status",
        JX_EXAM_OPTION_TYPE: "jx_exam_option_type",
        JX_EXAM_TOPIC_MEDIA_TYPE: "jx_exam_topic_media_type",
        JX_MESSAGE_TARGET_TYPE: "jx_message_target_type",
        SYS_LOG_RESPONSE_STATUS: "sys_log_response_status",
        JX_SUPPLIER_STATUS: "jx_supplier_status",
        JX_SITE_OPERATOR: "jx_site_operator",
        JX_INSPECT_ILLEGAL_TYPE: "jx_inspect_illegal_type",
        JX_INSPECT_STATUS: "jx_inspect_status",
        SRM_SUPPLIER_STATUS: "srm_supplier_status",
        JX_SUPPLIER_OFFICE_STATUS: "jx_supplier_office_status",
        JX_MANAGER_USER_OFFICE_STATUS: "jx_manager_user_office_status",
    },

    list(dictCodes) {
        return new Promise((resolve, reject) => {
            itemByCodes({
                dictCode: dictCodes.join(",")
            }).then(
                res => {
                    let data = res.data;
                    let keys = Object.keys(res.data);
                    for (let key of keys) {
                        let cacheKey = "sys::dict::" + key;
                        sessionStorage.setItem(cacheKey, JSON.stringify(data[key]));
                    }
                    resolve(res);
                }
            ).catch(
                ex => {
                    reject(ex);
                }
            )
        })
    },

    label(dictCode, value) {
        if (!value) {
            return value;
        }
        let cacheKey = "sys::dict::" + dictCode;
        let data = JSON.parse(sessionStorage.getItem(cacheKey));
        if (!data || Object.keys(data).length === 0) {
            return;
        }
        for (let obj of data) {
            if (obj.value === value) {
                return obj.label;
            }
        }
        return "未知项";
    }

}
